import { cn } from "../../../utils/cn.js";
import { cva } from "class-variance-authority";
import "react";
import { jsx } from "react/jsx-runtime";
//#region src/components/Spinner/Spinner.tsx
const spinnerVariants = cva([
	"relative box-border inline-block shrink-0 animate-spin rounded-full text-background-brand-primary [animation-duration:0.8s]",
	"bg-[conic-gradient(from_0deg,transparent_0%,transparent_20%,currentColor_100%)]",
	"[mask:radial-gradient(farthest-side,transparent_calc(100%-var(--spinner-stroke)),#000_calc(100%-var(--spinner-stroke)+0.5px))]",
	"after:absolute after:left-1/2 after:top-0 after:size-[var(--spinner-stroke)] after:-translate-x-1/2 after:rounded-full after:bg-current after:content-['']"
], {
	defaultVariants: { size: "md" },
	variants: { size: {
		lg: "h-8 w-8 [--spinner-stroke:3px]",
		md: "h-5 w-5 [--spinner-stroke:2px]",
		sm: "h-[15px] w-[15px] [--spinner-stroke:2px]",
		xs: "h-3 w-3 [--spinner-stroke:1.5px]"
	} }
});
/**
* Branded loading spinner matching the Curri loader treatment.
*
* Renders a comet: a round head in the brand primary color trailed by a
* tail that fades to transparent. Color follows `currentColor`, so a
* `text-*` class in `className` recolors the head and tail together.
*
* @param props - Spinner configuration including size variant
* @param props.size - Spinner diameter: xs (12px), sm (15px), md (20px), lg (32px)
* @param props.className - Additional classes for color or layout overrides
* @returns The rendered spinner element
*/
function Spinner({ className, size, ...props }) {
	return /* @__PURE__ */ jsx("span", {
		"aria-label": "Loading",
		role: "status",
		className: cn(spinnerVariants({ size }), className),
		...props
	});
}
//#endregion
export { Spinner, spinnerVariants };

//# sourceMappingURL=Spinner.js.map